export default "__VITE_ASSET__XXm6dhat__"